import Home from '././Home.data-manager-af-prt-pid.vue'

export default {
  Home
}